export { default } from '@/features/shiftCloseouts/pages/NewShiftCloseoutPage'
